import ReactMarkdown from "react-markdown";
import { formatTime } from "../../hooks/formatTime";

export default function ChatBubble({ msg, isTyping = false }) {
  const roleClass =
    msg.sender === "user" ? "user" : "ai";
    const formattedTime = formatTime(msg.timestamp)

  return (
    <div className={`chat-bubble ${roleClass}`}>
      <div className="bubble-content">
        {msg.sender === "ai" ? (
          <ReactMarkdown children = {msg.text} />
        ) : (
          msg.text
        )}
        {isTyping && <span className="typing-cursor">▍</span>}
      </div>

      {formattedTime && msg.sender === "user" && (
        <div className="timestamp" style={{ textAlign: "right" }}>{formattedTime}</div>
      )}
    </div>
  );
}